import { IconWithTooltip } from "../IconWithTooltip";
import { CopyIcon } from "@src/assets";

type Props = {
  value: string;
  text: string;
};

export const CopyButton = ({ value, text }: Props) => {
  return (
    <div onClick={() => navigator.clipboard.writeText(value)}>
      <div className="flex items-center gap-1">
        <IconWithTooltip
          tooltipText={text}
          id={`${text}-tooltip`}
          icon={CopyIcon}
        />
      </div>
    </div>
  );
};
